import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type SectionHeaderProps = {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
};

export function SectionHeader({ eyebrow, title, description, className }: SectionHeaderProps) {
  return (
    <div className={cn(className)}>
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">{eyebrow}</p>
      <h2 className="mt-4 font-serif text-2xl font-light tracking-tight text-foreground md:text-3xl">
        {title}
      </h2>
      {description != null && (
        <p className="mt-6 max-w-2xl text-muted-foreground leading-relaxed">{description}</p>
      )}
    </div>
  );
}
